module.exports = __webpack_public_path__ + "static/media/networking.60d1ac84.png";